export default __webpack_public_path__ + "static/computervisionicon-922ec3ef07721abbdd928d04e0f381a5.webp";